/** @jsx h */
// @flow

import { h, Fragment, VNode } from 'preact';
import { useCallback, useEffect, useState } from 'preact/hooks';
import { styled } from 'goober';
import CrossIcon from '../../assets/checkoutWidget/cross-icon.svg';
import { CHECKOUT_WIDGET_ID } from './constants';

type Props = {
  open: boolean,
  disableBackdropClick?: boolean,
  className?: string,
  children: VNode,
  onClose?: Function,
  outerModalClass: string,
  withCrossIcon: boolean,
};

const ModalContainer = styled('div')`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  overflow: hidden;
  .modalBackdrop {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: inherit;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .clickable {
    cursor: pointer;
  }
  .modalContentContainer {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: inherit;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .modalInnerContainer {
    box-shadow: 0px 0px 8px 2px rgb(0, 0, 0, 0.3);
    border-radius: 8px;
  }
  .closeIcon {
    position: absolute;
    top: -32px;
    right: 0;
    line-height: 0;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .closeIcon img {
    width: 100%;
    height: 100%;
  }
`;

const Modal = (props: Props) => {
  const {
    onClose,
    open,
    disableBackdropClick,
    children,
    className,
    outerModalClass,
    withCrossIcon,
  } = props;

  const [openModal, setOpenModal] = useState(open || false);

  const showModal = useCallback(() => {
    setOpenModal(true);
    document.getElementById(CHECKOUT_WIDGET_ID).style.overflow = 'hidden';
  }, []);

  const handleBackDropClick = useCallback((event) => {
    if (!disableBackdropClick) {
      closeModal(event);
    }
  }, []);

  const cleanUp = () => {
    document.getElementById(CHECKOUT_WIDGET_ID).style.overflow = null;
  };

  const closeModal = (event) => {
    cleanUp();
    setOpenModal(false);
    if (onClose) {
      onClose(event);
    }
  };

  useEffect(() => {
    if (open && openModal !== open) {
      showModal();
    }
    return () => {
      cleanUp();
    };
  }, [open]);

  return (
    <Fragment>
      {open && openModal && (
        <ModalContainer>
          <div
            className={`modalBackdrop  ${
              !disableBackdropClick ? 'clickable' : ''
            }`}
            onClick={handleBackDropClick}
          />
          <div className={`modalContentContainer ${outerModalClass}`}>
            <div className={`modalInnerContainer ${className || ''}`}>
              {withCrossIcon && (
                <div className='closeIcon' onClick={closeModal}>
                  <img src={CrossIcon} alt='close-icon' />
                </div>
              )}
              {children}
            </div>
          </div>
        </ModalContainer>
      )}
    </Fragment>
  );
};

Modal.defaultProps = {
  open: false,
  disableBackdropClick: false,
  className: '',
  withCrossIcon: true,
};

export default Modal;



// WEBPACK FOOTER //
// ./components/checkoutWidget/Modal.js